/* ============================================================
   Canopus Supply — Cinematic scroll layer v2 (homepage)
   Editions-style scrollytelling: every element's position,
   opacity and mask is driven CONTINUOUSLY by scroll position,
   in both directions, through a global inertia (lerp) filter —
   scroll down and things flow in; scroll up and they flow back.

   Zero dependencies. Safety:
   - No-op when prefers-reduced-motion is set.
   - No-op without JS (nothing is hidden by CSS alone).
   - Transforms / opacity / clip-path only — no layout writes.
   - Header, announcement bar, schema untouched. Homepage only.
   ============================================================ */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var main = document.getElementById('main');
  if (!main) return;

  document.documentElement.classList.add('cin-on');

  /* ---------- helpers -------------------------------------- */
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var easeOut = function (t) { t = 1 - clamp(t, 0, 1); return 1 - t * t * t; };
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || main).querySelectorAll(sel));
  }
  /* offsetTop chain — unaffected by our transforms */
  function docTop(el) {
    var t = 0;
    while (el) { t += el.offsetTop; el = el.offsetParent; }
    return t;
  }

  var vh = window.innerHeight;
  var A = window.innerWidth < 750 ? 0.55 : 1;   /* amplitude factor */

  /* ---------- registry ------------------------------------- */
  var items = [];

  function add(el, fx, o) {
    if (!el || el.__cin) return;
    el.__cin = true;
    el.classList.add(fx === maskFx ? 'cin-mask-fx' : 'cin-fx');
    items.push({ el: el, fx: fx, o: o || {}, top: 0, h: 1, lastP: null });
  }

  /* ---------- effect shapes (p = 0 entering at bottom …
                1 = fully exited at top) ---------------------- */

  /* rise in → hold → drift out; optional settle-scale + drift */
  function riseFx(el, p, o) {
    var e = easeOut((p - (0.03 + (o.stag || 0))) / 0.27);
    var x = clamp((p - 0.78) / 0.22, 0, 1);
    var dist = (o.dist || 46) * A;
    var y = (1 - e) * dist - x * dist * 0.7 + (0.5 - p) * (o.drift || 0) * A;
    var t = 'translate3d(0,' + y.toFixed(2) + 'px,0)';
    if (o.scale) t += ' scale(' + (0.958 + easeOut(p / 0.4) * 0.042).toFixed(4) + ')';
    el.style.transform = t;
    el.style.opacity = (e * (1 - x * 0.75)).toFixed(3);
  }

  /* masked line-rise for headings, scrubbed both ways */
  function maskFx(el, p, o) {
    var e = easeOut((p - (0.05 + (o.stag || 0))) / 0.28);
    var x = clamp((p - 0.80) / 0.20, 0, 1);
    var y = (1 - e) * 30 * A - x * 22 * A;
    el.style.clipPath = 'inset(' + ((1 - e) * 103).toFixed(1) + '% 0 -25% 0)';
    el.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0)';
    el.style.opacity = (Math.min(1, e * 1.4) * (1 - x * 0.75)).toFixed(3);
  }

  /* zoom-settle for large panels (before/after, newsletter) */
  function panelFx(el, p, o) {
    var e = easeOut(p / 0.42);
    var x = clamp((p - 0.82) / 0.18, 0, 1);
    var s = (o.from || 0.94) + e * (1 - (o.from || 0.94)) - x * 0.02;
    var y = (1 - e) * 46 * A;
    el.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0) scale(' + s.toFixed(4) + ')';
    el.style.opacity = (0.4 + e * 0.6).toFixed(3);
  }

  /* featured-product gallery: slide in from the left + float */
  function galleryFx(el, p) {
    var e = easeOut(p / 0.32);
    var x0 = (1 - e) * -60 * A;
    var y = (0.5 - p) * 34 * A;
    el.style.transform = 'translate3d(' + x0.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0)';
    el.style.opacity = e.toFixed(3);
  }

  /* ---------- tag the page --------------------------------- */
  function build() {
    /* section headers: subheading rises, heading mask-rises,
       copy follows — staggered by child index */
    $$('.section-header .prose').forEach(function (prose) {
      var i = 0;
      Array.prototype.forEach.call(prose.children, function (child) {
        if (/^H[1-6]$/.test(child.tagName)) add(child, maskFx, { stag: i * 0.035 });
        else add(child, riseFx, { stag: i * 0.035, dist: 34 });
        i++;
      });
    });

    /* product cards: stagger + per-column drift so rows shear
       apart subtly as you scroll (the Editions feel) */
    $$('.shopify-section').forEach(function (sec) {
      $$('.product-card', sec).forEach(function (card, i) {
        add(card, riseFx, {
          stag: Math.min((i % 4) * 0.028, 0.12),
          dist: 54, scale: true,
          drift: 6 + (i % 4) * 7
        });
      });
    });

    /* steps + testimonials */
    $$('.multi-column__item').forEach(function (item, i) {
      add(item, riseFx, {
        stag: Math.min((i % 5) * 0.03, 0.13),
        dist: 50, scale: true,
        drift: 8 + (i % 3) * 8
      });
    });

    /* FAQ entries */
    $$('.faq details, .faq .faq__category').forEach(function (q, i) {
      add(q, riseFx, { stag: Math.min(i * 0.02, 0.1), dist: 30 });
    });

    /* newsletter: panel zooms, content rises inside it */
    var nl = document.querySelector('#main .newsletter');
    if (nl) add(nl, panelFx, { from: 0.96 });
    $$('.newsletter .content > *').forEach(function (el, i) {
      add(el, riseFx, { stag: i * 0.03, dist: 26 });
    });

    /* before/after frame */
    var ba = document.querySelector('#main before-after');
    if (ba) add(ba, panelFx, { from: 0.94 });

    /* featured product */
    var fp = document.querySelector('[id$="__featured-product"]');
    if (fp) {
      var g = fp.querySelector('.product-gallery');
      if (g) add(g, galleryFx, {});
      $$('.product-info > *', fp).forEach(function (el, i) {
        add(el, riseFx, { stag: Math.min(i * 0.02, 0.12), dist: 30 });
      });
    }
  }

  /* ---------- hero (special: driven by raw page offset) ---- */
  var heroSec = document.querySelector('#main .shopify-section');
  var heroEl = heroSec ? heroSec.querySelector('slide-show, .slideshow') : null;
  var heroContent = heroSec ? heroSec.querySelector('.slideshow__slide-content') : null;
  var heroH = 0;
  if (heroEl) heroEl.classList.add('cin-fx');
  if (heroContent) heroContent.classList.add('cin-fx');

  function heroRender(sy) {
    if (!heroH) return;
    var p = clamp(sy / (heroH * 0.9), 0, 1);
    if (heroEl) {
      /* the whole hero recedes: slides down slower than the page
         (depth) while gently scaling away */
      heroEl.style.transformOrigin = '50% 30%';
      heroEl.style.transform =
        'translate3d(0,' + (p * heroH * 0.10).toFixed(1) + 'px,0) scale(' +
        (1 - p * 0.05).toFixed(4) + ')';
    }
    if (heroContent) {
      heroContent.style.transform = 'translate3d(0,' + (-p * 90 * A).toFixed(1) + 'px,0)';
      heroContent.style.opacity = clamp(1 - p * 1.3, 0, 1).toFixed(3);
    }
  }

  /* ---------- measurement ---------------------------------- */
  function measure() {
    vh = window.innerHeight;
    A = window.innerWidth < 750 ? 0.55 : 1;
    heroH = heroSec ? heroSec.offsetHeight : 0;
    items.forEach(function (it) {
      it.top = docTop(it.el);
      it.h = it.el.offsetHeight || 1;
      it.lastP = null;              /* force re-write after re-measure */
    });
  }

  /* ---------- render loop with global inertia --------------- */
  var smoothY = window.scrollY;
  var running = false;
  var idle = 0;

  function render(sy) {
    heroRender(sy);
    var bottom = sy + vh;
    items.forEach(function (it) {
      var p = clamp((bottom - it.top) / (vh + it.h), 0, 1);
      if (it.lastP !== null && Math.abs(p - it.lastP) < 0.0006) return;
      it.lastP = p;
      it.fx(it.el, p, it.o);
    });
  }

  function frame() {
    var target = window.scrollY;
    var d = target - smoothY;
    if (Math.abs(d) > 0.1) { smoothY += d * 0.16; idle = 0; }
    else { smoothY = target; idle++; }
    render(smoothY);
    if (idle < 20) requestAnimationFrame(frame);
    else running = false;
  }

  function wake() {
    if (!running) { running = true; idle = 0; requestAnimationFrame(frame); }
  }

  /* ---------- wiring ---------------------------------------- */
  window.addEventListener('scroll', wake, { passive: true });
  window.addEventListener('resize', function () { measure(); wake(); }, { passive: true });
  window.addEventListener('load', function () { measure(); wake(); });

  /* layout shifts (images loading, FAQ opening) → re-measure */
  if ('ResizeObserver' in window) {
    var pending = null;
    new ResizeObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () { measure(); wake(); }, 120);
    }).observe(document.body);
  }

  /* keep working inside the Shopify theme editor */
  document.addEventListener('shopify:section:load', function () {
    build(); measure(); wake();
  });

  /* ---------- boot ------------------------------------------ */
  build();
  measure();
  wake();
})();
